import React from "react";
import Tag from "./Tag";

const Ribbon = ({ villa }) => {
  const { ribbon, ribbon2 } = villa || {};
  return (
    <div className="flex items-center gap-0.5 absolute flex-wrap top-2 left-2 pr-10">
     {ribbon && <Tag text={ribbon} />}
     {ribbon2 && <Tag text={ribbon2} />}
    </div>
  );
};

export default Ribbon;
